webpackJsonp([242809538932529],{

/***/ 1331:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/costs-2011.af17f379.png";

/***/ }),

/***/ 1332:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/costs-2012.de0c17d0.png";

/***/ }),

/***/ 1333:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/costs-2013.14147e6d.png";

/***/ }),

/***/ 1334:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/costs-2014.0811e1c5.png";

/***/ }),

/***/ 1335:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/costs-2015.dddef9a9.png";

/***/ }),

/***/ 1336:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/costs-2016.6a677328.png";

/***/ }),

/***/ 1337:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/uninsured-2011.c8270dcd.png";

/***/ }),

/***/ 1338:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/uninsured-2012.4a1b4dd4.png";

/***/ }),

/***/ 1339:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/uninsured-2013.7c61c1d6.png";

/***/ }),

/***/ 1340:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/uninsured-2014.94ee3a26.png";

/***/ }),

/***/ 1341:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/uninsured-2015.43a8e63e.png";

/***/ }),

/***/ 1342:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/uninsured-2016.b2514bbe.png";

/***/ }),

/***/ 1343:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/making-progress.851ad5b3.png";

/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Exhibit10Module = __webpack_require__(840);
	
	var _Exhibit10Module2 = _interopRequireDefault(_Exhibit10Module);
	
	var _costs = __webpack_require__(1331);
	
	var _costs2 = _interopRequireDefault(_costs);
	
	var _costs3 = __webpack_require__(1332);
	
	var _costs4 = _interopRequireDefault(_costs3);
	
	var _costs5 = __webpack_require__(1333);
	
	var _costs6 = _interopRequireDefault(_costs5);
	
	var _costs7 = __webpack_require__(1334);
	
	var _costs8 = _interopRequireDefault(_costs7);
	
	var _costs9 = __webpack_require__(1335);
	
	var _costs10 = _interopRequireDefault(_costs9);
	
	var _costs11 = __webpack_require__(1336);
	
	var _costs12 = _interopRequireDefault(_costs11);
	
	var _uninsured = __webpack_require__(1337);
	
	var _uninsured2 = _interopRequireDefault(_uninsured);
	
	var _uninsured3 = __webpack_require__(1338);
	
	var _uninsured4 = _interopRequireDefault(_uninsured3);
	
	var _uninsured5 = __webpack_require__(1339);
	
	var _uninsured6 = _interopRequireDefault(_uninsured5);
	
	var _uninsured7 = __webpack_require__(1340);
	
	var _uninsured8 = _interopRequireDefault(_uninsured7);
	
	var _uninsured9 = __webpack_require__(1341);
	
	var _uninsured10 = _interopRequireDefault(_uninsured9);
	
	var _uninsured11 = __webpack_require__(1342);
	
	var _uninsured12 = _interopRequireDefault(_uninsured11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//  Styles
	
	
	//  Images
	
	
	var costImages = {
	  "2011": _costs2.default,
	  "2012": _costs4.default,
	  "2013": _costs6.default,
	  "2014": _costs8.default,
	  "2015": _costs10.default,
	  "2016": _costs12.default
	};
	
	var uninsuredImages = {
	  "2011": _uninsured2.default,
	  "2012": _uninsured4.default,
	  "2013": _uninsured6.default,
	  "2014": _uninsured8.default,
	  "2015": _uninsured10.default,
	  "2016": _uninsured12.default
	};
	
	var years = ["2011", "2012", "2013", "2014", "2015", "2016"];
	
	var Exhibit10 = function (_React$Component) {
	  _inherits(Exhibit10, _React$Component);
	
	  function Exhibit10() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Exhibit10);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = { currentYear: "2011" }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Exhibit10.prototype.handleClick = function handleClick(year, e) {
	    this.setState({ currentYear: year });
	    e.preventDefault();
	  };
	
	  Exhibit10.prototype.render = function render() {
	    var _this2 = this;
	
	    var currentYear = this.state.currentYear;
	
	
	    return _react2.default.createElement(
	      'figure',
	      null,
	      _react2.default.createElement(
	        'h2',
	        { className: 'title__block' },
	        'Cost barriers to receiving care fell as uninsured rates fell following ACA coverage expansions'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'instructions' },
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Select a year to see changes over time.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'nav',
	        { className: _Exhibit10Module2.default.year__nav },
	        _react2.default.createElement(
	          'ul',
	          { className: [_Exhibit10Module2.default.year__list, _Exhibit10Module2.default['year__list__' + currentYear]].join(" ") },
	          years.map(function (year) {
	            return _react2.default.createElement(
	              'li',
	              { key: year, className: [currentYear === year ? _Exhibit10Module2.default.year__list__item__active : "", _Exhibit10Module2.default.year__list__item].join(" ") },
	              _react2.default.createElement(
	                'a',
	                { href: '#year_' + year, 'aria-controls': '#year_' + year, onClick: function onClick(e) {
	                    return _this2.handleClick(year, e);
	                  } },
	                year
	              )
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _Exhibit10Module2.default.images },
	        _react2.default.createElement(
	          'ul',
	          { className: _Exhibit10Module2.default.image__list },
	          years.map(function (year) {
	            return _react2.default.createElement(
	              'li',
	              { key: year, id: 'year_' + year, className: _Exhibit10Module2.default.image__list__year, 'aria-hidden': currentYear === year ? false : true },
	              _react2.default.createElement(
	                'div',
	                { className: [_Exhibit10Module2.default.map, _Exhibit10Module2.default.map__cost].join(" ") },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  'Uninsured adults'
	                ),
	                _react2.default.createElement(
	                  'figure',
	                  null,
	                  _react2.default.createElement('img', { src: costImages[year], alt: '' }),
	                  _react2.default.createElement(
	                    'figcaption',
	                    null,
	                    year
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: [_Exhibit10Module2.default.map, _Exhibit10Module2.default.map__uninsured].join(" ") },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  'Adults who went without care because of costs'
	                ),
	                _react2.default.createElement(
	                  'figure',
	                  null,
	                  _react2.default.createElement('img', { src: uninsuredImages[year], alt: '' }),
	                  _react2.default.createElement(
	                    'figcaption',
	                    null,
	                    year
	                  )
	                )
	              )
	            );
	          })
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: _Exhibit10Module2.default.legend },
	          _react2.default.createElement(
	            'li',
	            { className: _Exhibit10Module2.default.legend__light },
	            'Less than 10%'
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: _Exhibit10Module2.default.legend__medium },
	            '10%-14%'
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: _Exhibit10Module2.default.legend__dark },
	            '15% or more'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'figcaption',
	        null,
	        'Data: Uninsured (ages 19\u201364): U.S. Census Bureau, 2011\u20132016 One-Year American Community Surveys. Public Use Micro Sample (ACS PUMS). Cost barriers (age 18 and older): 2011\u20132016 Behavioral Risk Factor Surveillance System (BRFSS).'
	      )
	    );
	  };
	
	  return Exhibit10;
	}(_react2.default.Component);
	
	exports.default = Exhibit10;
	module.exports = exports['default'];

/***/ }),

/***/ 840:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"year__nav":"src-components-Exhibits-Exhibit10----Exhibit10-module---year__nav---3x-gB","year__list":"src-components-Exhibits-Exhibit10----Exhibit10-module---year__list---DUedu","year__list__2012":"src-components-Exhibits-Exhibit10----Exhibit10-module---year__list__2012---cJReO","year__list__2013":"src-components-Exhibits-Exhibit10----Exhibit10-module---year__list__2013---4m1vK","year__list__2014":"src-components-Exhibits-Exhibit10----Exhibit10-module---year__list__2014---3KC0L","year__list__2015":"src-components-Exhibits-Exhibit10----Exhibit10-module---year__list__2015---11SG4","year__list__2016":"src-components-Exhibits-Exhibit10----Exhibit10-module---year__list__2016---38VEE","year__list__item":"src-components-Exhibits-Exhibit10----Exhibit10-module---year__list__item---2mMZV","year__list__item__active":"src-components-Exhibits-Exhibit10----Exhibit10-module---year__list__item__active---3ez30","image__list":"src-components-Exhibits-Exhibit10----Exhibit10-module---image__list---1bvdB","image__list__year":"src-components-Exhibits-Exhibit10----Exhibit10-module---image__list__year---TvGoT","map":"src-components-Exhibits-Exhibit10----Exhibit10-module---map---30kX9","legend":"src-components-Exhibits-Exhibit10----Exhibit10-module---legend---3WHK6","legend__light":"src-components-Exhibits-Exhibit10----Exhibit10-module---legend__light---25ksu","legend__medium":"src-components-Exhibits-Exhibit10----Exhibit10-module---legend__medium---w-1J7","legend__dark":"src-components-Exhibits-Exhibit10----Exhibit10-module---legend__dark---2rnmK"};

/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _ThemeList = __webpack_require__(64);
	
	var _ThemeList2 = _interopRequireDefault(_ThemeList);
	
	var _PageHeader = __webpack_require__(103);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _Exhibit = __webpack_require__(538);
	
	var _Exhibit2 = _interopRequireDefault(_Exhibit);
	
	var _ThemeNavFooter = __webpack_require__(104);
	
	var _ThemeNavFooter2 = _interopRequireDefault(_ThemeNavFooter);
	
	var _Button = __webpack_require__(22);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ShareExhibit = __webpack_require__(85);
	
	var _ShareExhibit2 = _interopRequireDefault(_ShareExhibit);
	
	var _caseStudyNewYork = __webpack_require__(106);
	
	var _caseStudyNewYork2 = _interopRequireDefault(_caseStudyNewYork);
	
	var _makingProgress = __webpack_require__(1343);
	
	var _makingProgress2 = _interopRequireDefault(_makingProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//  Components
	var Theme4Page = function Theme4Page(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'main',
	    null,
	    _react2.default.createElement(
	      'article',
	      null,
	      _react2.default.createElement(_PageHeader2.default, {
	        data: data.allThemesJson.edges[3].node,
	        img: _makingProgress2.default
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'section__title' },
	          'There have been widespread gains in health care access'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'During the first three years of the Affordable Care Act\u2019s major insurance coverage expansions, the adult uninsured rate declined by at least five percentage points in 47 states.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'And in nearly three-quarters of states, substantially fewer adults skipped needed care because of costs. States that expanded their Medicaid programs have made the largest gains.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#26' },
	                  '26'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'section__content section__exhibit section__exhibit__padded section__full section__exhibit__interactive' },
	          _react2.default.createElement(_Exhibit2.default, null),
	          _react2.default.createElement(_ShareExhibit2.default, {
	            exhibit: 'exhibit-10',
	            site: data.site.siteMetadata,
	            social: data.allSocialJson.edges })
	        )
	      ),
	      _react2.default.createElement('hr', { className: 'section__divider' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'section__title' },
	          'Nursing home care has improved, and home health patients have gained physical mobility'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__narrow' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'The percentage of home health patients who got better at walking or moving around \u2014 a key measure of quality of care \u2014 rose substantially in every state. In nursing homes, the potentially harmful use of antipsychotic drugs as \u201Cchemical restraints\u201D has fallen in nearly all states. This change likely reflects the goals of the National Partnership to Improve Dementia Care in Nursing Homes, which supports state-based coalitions in efforts to reduce inappropriate antipsychotic drug use and improve care for residents with dementia.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#27' },
	                  '27'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__exhibit section__exhibit__padded section__content__wide' },
	            _react2.default.createElement(
	              'figure',
	              null,
	              _react2.default.createElement('img', { className: 'exhibit__image__padded', src: (0, _gatsbyLink.withPrefix)('/img/exhibits/exhibit-11-web.png'), alt: '' }),
	              _react2.default.createElement(
	                'figcaption',
	                null,
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Notes: Chemical restraints means use of antipsychotic medication.'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Data: OASIS (via CMS Home Health Compare); MDS (via CMS Nursing Home Compare).'
	                )
	              )
	            ),
	            _react2.default.createElement(_ShareExhibit2.default, {
	              exhibit: 'exhibit-11',
	              site: data.site.siteMetadata,
	              social: data.allSocialJson.edges })
	          )
	        )
	      ),
	      _react2.default.createElement('hr', { className: 'section__divider' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'section__title' },
	          'Tobacco use continues to wane'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Adult smoking rates fell by at least three percentage points in all but four states between 2011 and 2016.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'States with some of the highest rates, such as Nevada and Oklahoma, saw the largest declines.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#28' },
	                  '28'
	                )
	              ),
	              ' States like California with long-standing comprehensive tobacco control policies have seen substantial reductions in health care spending because of lower smoking rates.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#29' },
	                  '29'
	                )
	              ),
	              ' Limiting tobacco use continues to represent a major opportunity for states to improve public health.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#30' },
	                  '30'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'section__content section__exhibit section__exhibit__padded section__full' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'title__block' },
	            'Tobacco use continues to decline: Nevada and Oklahoma had among the largest reductions in adult smoking between 2011 and 2016'
	          ),
	          _react2.default.createElement(
	            'figure',
	            null,
	            _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/img/exhibits/exhibit-12-web.png'), alt: '' }),
	            _react2.default.createElement(
	              'figcaption',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'Data: 2011, 2013, and 2016 Behavioral Risk Factor Surveillance System (BRFSS).'
	              )
	            )
	          ),
	          _react2.default.createElement(_ShareExhibit2.default, {
	            exhibit: 'exhibit-12',
	            site: data.site.siteMetadata,
	            social: data.allSocialJson.edges })
	        )
	      ),
	      _react2.default.createElement('hr', { className: 'section__divider' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'section__title' },
	          'Avoidable hospital use has declined'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Hospital readmission rates for elderly Medicare beneficiaries continued to fall in nearly half the states (particularly those with the highest rates) during the 2012\u201315 period.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'This reduction was the goal of federal financial penalties, as well as initiatives that brought hospitals and postacute care providers together to improve patients\u2019 transitions in care.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#31' },
	                  '31'
	                )
	              ),
	              ' There was also a continuing reduction in potentially preventable hospital admissions in several states, possibly because of better ambulatory care management.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'section section__heavy' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__narrow' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'What Is Being Done?'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__wide' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'States\u2019 gains likely reflect the influence of government policies, regulatory actions, and collaborative improvement efforts, all of which may be reinforced by the public reporting of performance data by the federal government, states, and other groups.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'With federal assistance, many states also are working with health plans, care providers, and other stakeholders to promote quality measurement and improvement in Medicaid and to spread payment and delivery system transformation more broadly.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#32' },
	                  '32'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'At the same time, recognition that performance incentives can sometimes be gamed, or can unfairly penalize providers treating a large share of vulnerable or high-need patients, is prompting discussions of how to improve these incentives.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#33' },
	                  '33'
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'section section__case_study' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'figure',
	            { className: 'section__content section__content__figure case_study__figure' },
	            _react2.default.createElement(
	              'div',
	              { className: 'case_study__figure__wrapper' },
	              _react2.default.createElement(_caseStudyNewYork.ReactComponent, null)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__limit' },
	            _react2.default.createElement(
	              'h4',
	              { className: 'case_study__label' },
	              'A Closer Look:'
	            ),
	            _react2.default.createElement(
	              'h3',
	              { className: 'case_study__title' },
	              'New York Moves to Improve'
	            ),
	            _react2.default.createElement(_Button2.default, { to: '/case-study/new-york-moves-to-improve', text: 'Keep Reading' })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_ThemeNavFooter2.default, { themes: data.allThemesJson.edges }),
	    _react2.default.createElement(
	      'div',
	      { className: 'section section__notes' },
	      _react2.default.createElement(
	        'div',
	        { className: 'section__row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__content' },
	          _react2.default.createElement(
	            'ol',
	            { start: '26', style: { counterReset: "item 25" }, className: 'list__notes' },
	            _react2.default.createElement(
	              'li',
	              { id: '26' },
	              'Susan L. Hayes et al., ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'What\u2019s at Stake: States\u2019 Progress on Health Coverage and Access to Care, 2013\u20132016'
	              ),
	              ' (The Commonwealth Fund, Dec. 2017), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.commonwealthfund.org/publications/issue-briefs/2017/dec/states-progress-health-coverage-and-access' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'http://www.commonwealthfund.org/publications/issue-briefs/2017/dec/states-progress-health-coverage-and-access'
	                )
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '27' },
	              'Centers for Medicare and Medicaid Services, ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'National Partnership to Improve Dementia Care in Nursing Homes'
	              ),
	              ' (CMS, n.d.), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.cms.gov/Medicare/Provider-Enrollment-and-Certification/SurveyCertificationGenInfo/National-Partnership-to-Improve-Dementia-Care-in-Nursing-Homes.html' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'https://www.cms.gov/Medicare/Provider-Enrollment-and-Certification/SurveyCertificationGenInfo/National-Partnership-to-Improve-Dementia-Care-in-Nursing-Homes.html'
	                )
	              ),
	              '. The Partnership built on the Advancing Excellence in America\u2019s Nursing Homes Campaign, launched in 2007 with support from the Commonwealth Fund; see: National Nursing Home Quality Improvement Campaign, ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Campaign History'
	              ),
	              ' (NNHQIC, n.d.), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.nhqualitycampaign.org/history.aspx' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'https://www.nhqualitycampaign.org/history.aspx'
	                )
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '28' },
	              'Rebekah R. Rhoades and Laura A. Beebe, \u201CTobacco Control and Prevention in Oklahoma: Best Practices in a Preemptive State,\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'American Journal of Preventive Medicine'
	              ),
	              ' 48, no. 1, Suppl. 1 (Jan. 2015): S6\u2013S12, ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.ajpmonline.org/article/S0749-3797(14)00497-8/fulltext' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'http://www.ajpmonline.org/article/S0749-3797(14)00497-8/fulltext'
	                )
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '29' },
	              'James Lightwood and Stanton A. Glantz, \u201CThe Effect of the California Tobacco Control Program on Smoking Prevalence, Cigarette Consumption and Healthcare Costs: 1989\u20132008,\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'PLoS ONE'
	              ),
	              ' 8, no. 2 (Feb. 2013), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://doi.org/10.1371/journal.pone.0047145' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'https://doi.org/10.1371/journal.pone.0047145'
	                )
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '30' },
	              'National Center for Chronic Disease Prevention and Health Promotion, ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Best Practices for Comprehensive Tobacco Control Programs \u2014 2014'
	              ),
	              ' (Centers for Disease Control and Prevention, 2014), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.cdc.gov/tobacco/stateandcommunity/best_practices/index.htm?s_cid=cs_3281' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'https://www.cdc.gov/tobacco/stateandcommunity/best_practices/index.htm?s_cid=cs_3281'
	                )
	              ),
	              '; and National Governors Association, ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Health Investments That Pay Off: Taking a Comprehensive Approach to Tobacco Control'
	              ),
	              ' (NGA Center for Best Practices, Aug. 16, 2016), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.nga.org/files/live/sites/NGA/files/pdf/2016/1608HealthInvestmentsTobacco.pdf' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'https://www.nga.org/files/live/sites/NGA/files/pdf/2016/1608HealthInvestmentsTobacco.pdf'
	                )
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '31' },
	              'Robert Fornango et al., ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Project Evaluation Activity in Support of Partnership for Patients Interim Evaluation Report, Final September 2015'
	              ),
	              ' (Centers for Medicare and Medicaid Services, revised Dec. 29, 2015), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://downloads.cms.gov/files/cmmi/pfp-interimevalrpt.pdf' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'https://downloads.cms.gov/files/cmmi/pfp-interimevalrpt.pdf'
	                )
	              ),
	              '; and David Ruiz et al., ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Evaluation of the Community- Based Care Transitions Program: Final Evaluation Report'
	              ),
	              ' (Centers for Medicare and Medicaid Services, Nov. 2017), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://downloads.cms.gov/files/cmmi/cctp-final-eval-rpt.pdf' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'https://downloads.cms.gov/files/cmmi/cctp-final-eval-rpt.pdf'
	                )
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '32' },
	              'Lauren S. Hughes, Alon Peltz, and Patrick H. Conway, \u201CState Innovation Model Initiative: A State-Led Approach to Accelerating Health Care System Transformation,\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'JAMA'
	              ),
	              ' 313, no. 13 (Apr. 7, 2015): 1317\u201318, ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://jamanetwork.com/journals/jama/article-abstract/2190630' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'https://jamanetwork.com/journals/jama/article-abstract/2190630'
	                )
	              ),
	              '; Julia C. Martinez, Martha P. King, and Richard Cauchi, ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Improving the Health Care System: Seven State Strategies'
	              ),
	              ' (National Conference of State Legislatures, July 2016), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.ncsl.org/Portals/1/Documents/Health/ImprovingHealthSystemsBrief16.pdf' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'http://www.ncsl.org/Portals/1/Documents/Health/ImprovingHealthSystemsBrief16.pdf'
	                )
	              ),
	              '; Martha Hostetter, Sarah Klein, and Douglas McCarthy, ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Hennepin Health: A Care Delivery Paradigm for New Medicaid Beneficiaries'
	              ),
	              ' (The Commonwealth Fund, Oct. 2016), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.commonwealthfund.org/publications/case-studies/2016/oct/hennepin-health' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'http://www.commonwealthfund.org/publications/case-studies/2016/oct/hennepin-health'
	                )
	              ),
	              '; and Sara Rosenbaum et al., ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Medicaid Payment and Delivery System Reform: Early Insights from 10 Medicaid Expansion States'
	              ),
	              ' (The Commonwealth Fund, Oct. 2017), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.commonwealthfund.org/publications/issue-briefs/2017/oct/medicaid-payment-reform-10-expansion-states' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'http://www.commonwealthfund.org/publications/issue-briefs/2017/oct/medicaid-payment-reform-10-expansion-states'
	                )
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '33' },
	              'Qian Gu et al., \u201CThe Medicare Hospital Readmissions Reduction Program: Potential Unintended Consequences for Hospitals Serving Vulnerable Populations,\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Health Services Research'
	              ),
	              ' 49, no. 3 (June 2014): 818\u201337, ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://onlinelibrary.wiley.com/doi/abs/10.1111/1475-6773.12150' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'https://onlinelibrary.wiley.com/doi/abs/10.1111/1475-6773.12150'
	                )
	              ),
	              '; Andrew M. Ibrahim et al., \u201CAssociation of Coded Severity with Readmission Reduction After the Hospital Readmissions Reduction Program,\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'JAMA Internal Medicine'
	              ),
	              ' 178, no. 2 (Feb. 1, 2018): 290\u201392, ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://jamanetwork.com/journals/jamainternalmedicine/article-abstract/2663252' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'https://jamanetwork.com/journals/jamainternalmedicine/article-abstract/2663252'
	                )
	              ),
	              '; and Ashish K. Jha, \u201CTo Fix the Hospital Readmissions Program, Prioritize What Matters,\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'JAMA'
	              ),
	              ' 319, no. 5 (Feb. 6, 2018): 431\u201333, ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://jamanetwork.com/journals/jama/fullarticle/2671454' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'https://jamanetwork.com/journals/jama/fullarticle/2671454'
	                )
	              ),
	              '.'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Theme4Page;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-making-progress-js-a6469d7bf71a3ea4c8d9.js